var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "landing-page-list"
  }, [_c('h4', {
    staticClass: "main-header"
  }, [_vm._v(_vm._s(_vm.$t('navigation_landing_pages')))]), _c('v-simple-table', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('thead', [_c('tr', [_c('th', {
          staticClass: "text-left"
        }, [_vm._v(" Name ")]), _c('th', {
          staticClass: "text-left"
        }, [_vm._v(" Actions ")])])]), _c('tbody', _vm._l(_vm.landingPages, function (landingPage) {
          return _c('tr', {
            key: `landing-page-${landingPage.id}`
          }, [_c('td', [_vm._v(_vm._s(landingPage.name))]), _c('td', [_c('v-btn', {
            attrs: {
              "color": "primary",
              "icon": ""
            },
            on: {
              "click": function ($event) {
                return _vm.goToLandingPage(landingPage.id);
              }
            }
          }, [_c('v-icon', [_vm._v("mdi-pencil")])], 1)], 1)]);
        }), 0)];
      },
      proxy: true
    }])
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }